export const colors = {
    // primary: "limegreen",
    primary: "purple",
    secondary: ""
}